// ** React Imports
import { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import {
    Card,
    CardActionArea,
    Divider,
    Typography,
} from '@mui/material'
import { useNavigate, useParams } from "react-router-dom";
import axios from 'axios'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import { useToast } from '../../../components/ToastProvider';

export default function Index() {
    const { showToast, hideToast } = useToast();
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const [reports, setReports] = useState<any[]>([])
    const { menu } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        getData()
    }, [])
    const getData = () => {
        showToast("Loading...", "loading");
        let url = apiUrl.apiUrl + '/report/dynamic/list/'+menu

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setReports(data)
                    hideToast();
                } else {
                    showToast(response.data.message, "success");
                }
            })
    }

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                        >
                        <CardHeader title={`REPORT ${menu.toUpperCase()}`} />
                    </Box>
                    <Divider />
                        <CardContent
                        sx={{
                            minHeight: { md: "calc(100vh - 200px)" },
                            display: "flex",
                            justifyContent: "center"
                        }}
                        >
                        <Grid
                            container
                            spacing={3}
                            justifyContent="center"
                            sx={{
                                maxWidth: 1200,
                                width: "100%"
                            }}
                            >
                            {reports.map((report, i) => (
                            <Grid item xs={12} sm={6} md={4} key={i}>
                                <Card
                                sx={{
                                    borderRadius: 3,
                                    cursor: "pointer",
                                    color: "white",
                                    overflow: "hidden",
                                    transition: "all .35s ease",
                                    background: report.color,
                                    boxShadow: "0 15px 35px rgba(0,0,0,0.2)",

                                    "&:hover": {
                                    transform: "translateY(-8px) scale(1.03)",
                                    boxShadow: "0 25px 55px rgba(0,0,0,0.3)"
                                    }
                                }}
                                >
                                <CardActionArea
                                    sx={{
                                    height: "100%",
                                    "& .MuiTouchRipple-root span": {
                                        backgroundColor: "rgba(255,255,255,0.4)"
                                    }
                                    }}
                                    onClick={()=>{
                                        navigate('/report/detail/' + report.id)
                                    }}
                                >
                                    <CardContent>
                                    <Box
                                        sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        mb: 2
                                        }}
                                    >
                                        <Icon icon={report.icon} width={40} />

                                        <Box
                                        sx={{
                                            fontSize: 11,
                                            px: 1.5,
                                            py: 0.5,
                                            borderRadius: 2,
                                            background: "rgba(255,255,255,0.25)"
                                        }}
                                        >
                                        {report.menu}
                                        </Box>
                                    </Box>

                                    <Typography variant="h6" fontWeight={600}>
                                        {report.title}
                                    </Typography>

                                    <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
                                        {report.desc}
                                    </Typography>
                                    </CardContent>
                                </CardActionArea>
                                </Card>
                            </Grid>
                            ))}
                        </Grid>
                        </CardContent>
                </div>
            </Grid>
        </Grid>
    )
}